import React from 'react';
import './CourseCard.css';

function CourseCard({ course, onEnroll }) {
  return (
    <div className="course-card">
      <div className="course-header">
        <h2 className="course-title">{course.title}</h2>
        <span className="course-type">{course.type}</span>
      </div>
      
      <p className="course-description">{course.description}</p>
      
      <div className="course-info">
        <div className="info-item">
          <span className="info-label">Duration:</span>
          <span className="info-value">{course.duration}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Price:</span>
          <span className="info-value price">₹{course.price}</span>
        </div>
      </div>
      
      <div className="course-features">
        <h3>What you'll learn:</h3>
        <ul>
          {course.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
      
      <button className="enroll-button" onClick={() => onEnroll(course)}>
        Enroll Now
      </button>
    </div>
  );
}

export default CourseCard;
